import { requestREST } from "~/client/http/CommonHTTP";
import {
  DealerEpdIProps,
  EpdBlockIProps,
} from "~/components/Forms/DealerPassportForm2/requests/getEpd";

export const updateEpd = async (
  dealerId: string,
  epdBlocks: EpdBlockIProps[]
): Promise<DealerEpdIProps> => {
  const { data } = await requestREST.put("/dealer/epd", {
    dealerId: Number(dealerId),
    epdBlocks,
  });
  return data;
};
